module.exports = __webpack_public_path__ + "media/img/pages/companies/ckw-5044ae96977542afb071b124021238fb.webp";